export default function buildStructuredProduct({ product, router,configurations }) {
  if(!product || !router) {
    return {};
  }

  const articleUrl = 'https://www.article.com';

  const structuredProduct = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.title,
    image: product.media && product.media.length ? product.media[0].url : '',
    description: product.description,
    mpn: product.skuNo,
    sku: product.skuNo,
    url: `${articleUrl}${router.resolve({ name: 'product', params: { id: product.hashKey, slug: product.slug } }).href}`,
    productID: product.skuNo,
    itemCondition: 'https://schema.org/NewCondition',
    brand: {
      '@type': 'Brand',
      name: 'Article',
      logo: 'https://images.article.com/logos/article/article_logo_234x30.png',
      url: import.meta.env.VITE_STOREFRONT_BASE_URL,
    },
  };


  if( configurations ){
    configurations.forEach((group) =>{
      if(group.name === 'Seating' || group.name === 'Size') {
        group.configuration.forEach((config) => {
          if (config.selected) {
            structuredProduct.size = config.value;
          }
        });
      }

      if( group.name === 'Color') {
        group.configuration.forEach((config) => {
          if (config.selected) {
            structuredProduct.color = config.value;
          }
        });
      }
      if( group.name === 'Material') {
        group.configuration.forEach((config) => {
          if (config.selected) {
            structuredProduct.material = config.value;
          }
        });
      }
    });
  }

  if (product.review && product.review.count && product.review.rating) {
    structuredProduct.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: product.review.rating,
      worstRating: '1',
      bestRating: '5',
      ratingCount: product.review.count,
    };
  }

  if (product.variation && product.variation.length) {
    structuredProduct.isRelatedTo = product.variation.map((variation) => ({
      '@id': `${articleUrl}${router.resolve({ name: 'product', params: { id: variation.hashKey, slug: variation.slug } }).href}#product`,
      '@type': 'Product',
      name: variation.title,
      url: `${articleUrl}${router.resolve({ name: 'product', params: { id: variation.hashKey, slug: variation.slug } }).href}`,
    }));
  }

  if(product.height && product.width && product.depth) {
    structuredProduct.height = `${product.height} in`;
    structuredProduct.width = `${product.width} in`;
    structuredProduct.depth = `${product.depth} in`;
  }

  const category = product?.navigationCategory?.[0];
  if(category) {
    structuredProduct.category = category.name;
  }

  return structuredProduct;
}

